// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportOrientation } from './report-orientation.action';
export const report_orientation = createReducer(null, on(setCustomPDFReportBuilderStore, setReportOrientation, (state, action) => {
    return action.report_orientation;
}));
